import { Component, OnInit } from '@angular/core';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlayerService } from '../../../services/player.service';
import { ApplicationService } from '../../../services/application.service';
import { Player } from '../../../models/Player';
import { CreatePlayerRequest } from '../../../models/createPlayerRequest';
import { ASSIGNABLE_PERMISSIONS } from '../../../models/constants';
@Component({
  selector: 'app-player-admin',
  standalone: true,
  imports: [NgIf, NgFor, FormsModule],
  templateUrl: './player-admin.component.html',
  styleUrl: './player-admin.component.css'
})
export class PlayerAdminComponent implements OnInit {
  constructor(private applicationService:ApplicationService, private playerService:PlayerService) {}

  containerDisplay:string = 'LIST';
  allPlayers:Array<Player> = [];
  createPlayerRequest:CreatePlayerRequest = this.buildBlankCreatePlayerRequest();
  showCreatePlayerError:boolean = false;
  playerToUpdate:Player = this.buildBlankPlayer();
  permissionOptions = ASSIGNABLE_PERMISSIONS;

  ngOnInit(): void {
    this.getAllPlayers();
  }

  buildBlankCreatePlayerRequest():CreatePlayerRequest {
    return { firstName: '', lastName: '', email: null, phone: null, handicapIndex: 0, permissions: [] };
  }

  buildBlankPlayer():Player {
    return { id:-1, email: null, phone: null, permissions: [], firstName: '', lastName: '', handicapIndex: 0 };
  }

  async getAllPlayers():Promise<void> {
    this.applicationService.showGlobalSpinner();
    this.allPlayers = await this.playerService.searchPlayers(null);
    this.applicationService.hideGlobalSpinner();
  }

  editPlayer(player:Player):void {
    this.playerToUpdate = { ...player, permissions: player.permissions ? [...player.permissions] : [] };
    this.containerDisplay = 'UPDATE';
  }

  hasPermission(permissions:Array<string>|null|undefined, permission:string):boolean {
    return !!permissions && permissions.indexOf(permission) >= 0;
  }

  togglePermission(target:{ permissions?:Array<string>|null }, permission:string, isChecked:boolean):void {
    const current = target.permissions ? [...target.permissions] : [];
    const index = current.indexOf(permission);

    if(isChecked && index < 0) current.push(permission);
    else if(!isChecked && index >= 0) current.splice(index, 1);

    target.permissions = current;
  }

  async createNewPlayer():Promise<void> {
    this.applicationService.showGlobalSpinner();
    let id = await this.playerService.createPlayer(this.createPlayerRequest)
    if(id > 0)
      this.createPlayerRequest = this.buildBlankCreatePlayerRequest();
    await this.getAllPlayers();
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'LIST';
  }

  async updatePlayer():Promise<void> {
    this.applicationService.showGlobalSpinner();
    let id = await this.playerService.updatePlayer(this.playerToUpdate, true)
    if(id > 0)
      this.playerToUpdate = this.buildBlankPlayer();
    await this.getAllPlayers();
    this.applicationService.hideGlobalSpinner();
    this.containerDisplay = 'LIST';
  }

  onPhoneInput() {
    const value = this.createPlayerRequest.phone ?? '';
    this.createPlayerRequest.phone =
      value.replace(/[^0-9]/g, '').slice(0, 10);
  }
}
